const BATCH_SECONDS_PER_URL = 45;
const BATCH_QUEUE_SECONDS = 20 * 60;
const REALTIME_SECONDS_PER_URL = 90;
const REALTIME_PARALLEL_PAGES = 4;

export function estimateSchemaRunSeconds(urlCount, useBatchApi) {
	if (urlCount <= 0) return 0;
	if (useBatchApi) return urlCount * BATCH_SECONDS_PER_URL + BATCH_QUEUE_SECONDS;
	return Math.ceil(urlCount / REALTIME_PARALLEL_PAGES) * REALTIME_SECONDS_PER_URL;
}

export function formatRunDuration(totalSeconds) {
	const minutes = Math.max(5, Math.ceil(totalSeconds / 60 / 5) * 5);
	if (minutes < 60) return `about ${minutes} minutes`;
	const hours = Math.floor(minutes / 60);
	const remainder = minutes % 60;
	const hourLabel = `${hours} hour${hours === 1 ? "" : "s"}`;
	if (remainder === 0) return `about ${hourLabel}`;
	return `about ${hourLabel} ${remainder} minutes`;
}
